import _reduce from 'lodash/reduce';
import _isEqual from 'lodash/isEqual';
import _isEmpty from 'lodash/isEmpty';

export function isEmpty(value: any) {
	return (
		value === undefined ||
		value === null ||
		// eslint-disable-next-line use-isnan
		value === NaN ||
		(typeof value === 'object' && _isEmpty(value)) ||
		(typeof value === 'string' && value.trim().length === 0)
	);
}

export function isArray(arr: unknown) {
	return Array.isArray(arr);
}

export function isNumeric(num: unknown) {
	return !isNaN(`${num}` as unknown as number);
}

export function toNumber(num: string) {
	return parseFloat(num);
}

export function isDate(date: string) {
	// @ts-ignore
	return new Date(date) !== 'Invalid Date' && !isNaN(new Date(date));
}

export function toDate(date: string) {
	return new Date(date);
}

export function toTimestamp(date: string) {
	const datum = Date.parse(date);
	return datum / 1000;
}

export function hhmmToNum(hhmm: string | undefined) {
	if (!hhmm) return false;
	const pts = hhmm.split(':');
	if (pts.length !== 2) return false;
	const [hh, mm] = pts;
	return parseInt(hh) * 60 + parseInt(mm);
}

export function diffObjects(a: Record<string, any>, b: Record<string, any>) {
	return _reduce(
		a,
		function (result, value, key) {
			return _isEqual(value, b[key]) ? result : { ...result, [key]: value };
		},
		{}
	);
}

export function formatBytes(bytes: number, decimals = 2) {
	if (bytes === 0) return '0 Bytes';

	const k = 1024;
	const dm = decimals < 0 ? 0 : decimals;
	const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

	const i = Math.floor(Math.log(bytes) / Math.log(k));

	return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

export function fileToBlob(file: Blob): Promise<Blob> {
	return new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.onload = () => {
			const arrayBuffer = reader.result as ArrayBuffer;
			if (arrayBuffer) {
				const array = new Uint8Array(arrayBuffer);
				const blob = new Blob([array]);
				resolve(blob);
			}
		};
		reader.readAsArrayBuffer(file);
	});
}
